module.exports = __webpack_public_path__ + "img/wx-qr.3e726c7b.png";